import React from "react";
import IndexColList from "./IndexColList";
import IndexRow from "./IndexRow";
import { Button, Row, Space, Divider } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import classes from "./styles.module.css";

export default function IndexMappingTable(props) {
  return (
    <div className={classes.mapping_table_div}>
      <table>
        <thead>
          <tr>
            <IndexColList
              allIndexes={props.allIndexes}
              selectedCols={props.selectedCols}
              updateColumn={props.updateColumn}
              getColumns={props.getColumns}
              addColumn={props.addColumn}
              removeColumn={props.removeColumn}
            />
          </tr>
        </thead>
        <tbody>
          {props.rows.map((el, index) => (
            <tr key={index}>
              <IndexRow
                list={el}
                indexOptions={props.allIndexes}
                selectedCols={props.selectedCols}
                updateDataRecord={props.updateDataRecord}
                rowIndex={index}
                remove={props.remove}
                getIndexOptions={props.getIndexOptions}
              />
            </tr>
          ))}
        </tbody>
      </table>
      {/* <Space direction="vertical"> */}

      {props.selectedCols.length > 0 ? (
        <Button onClick={props.addRow} type="link" icon={<PlusOutlined />}>
          Add Row
        </Button>
      ) : null}
      {/* </Space> */}
    </div>
  );
}
